import { v4 as uuidv4 } from "uuid";

import { USState } from "@/src/lib/us-states";
import { Location, LocationRole } from "@/src/models/location";

// Google Maps Places API requires coordinate bounding boxes for state-based location restricting/biasing
export const stateCodeToLocationBoundsMapping: Partial<
  Record<USState, { low: { lat: number; lng: number }; high: { lat: number; lng: number } }>
> = {
  [USState.CA]: { low: { lat: 32.53, lng: -124.41 }, high: { lat: 42.01, lng: -114.13 } },
  [USState.TX]: { low: { lat: 25.84, lng: -106.65 }, high: { lat: 36.5, lng: -93.51 } },
  [USState.IL]: { low: { lat: 36.97, lng: -91.51 }, high: { lat: 42.51, lng: -87.49 } },
  [USState.FL]: { low: { lat: 24.51, lng: -87.63 }, high: { lat: 31.0, lng: -80.03 } },
  [USState.GA]: { low: { lat: 30.36, lng: -85.61 }, high: { lat: 35.0, lng: -80.84 } },
  [USState.IN]: { low: { lat: 37.77, lng: -88.1 }, high: { lat: 41.76, lng: -84.78 } },
  [USState.UT]: { low: { lat: 37.0, lng: -114.05 }, high: { lat: 42.0, lng: -109.04 } },
  [USState.KS]: { low: { lat: 37.0, lng: -102.05 }, high: { lat: 40.0, lng: -94.59 } },
  [USState.OH]: { low: { lat: 38.4, lng: -84.82 }, high: { lat: 41.98, lng: -80.52 } },
  [USState.NV]: { low: { lat: 35.0, lng: -120.01 }, high: { lat: 42.0, lng: -114.04 } },
  [USState.AL]: { low: { lat: 30.22, lng: -88.47 }, high: { lat: 35.01, lng: -84.89 } },
  [USState.AK]: { low: { lat: 51.21, lng: -179.15 }, high: { lat: 71.37, lng: 179.78 } },
  [USState.AZ]: { low: { lat: 31.33, lng: -114.82 }, high: { lat: 37.0, lng: -109.05 } },
  [USState.AR]: { low: { lat: 33.0, lng: -94.62 }, high: { lat: 36.5, lng: -89.64 } },
  [USState.CO]: { low: { lat: 36.99, lng: -109.06 }, high: { lat: 41.0, lng: -102.04 } },
  [USState.CT]: { low: { lat: 40.98, lng: -73.73 }, high: { lat: 42.05, lng: -71.79 } },
  [USState.DE]: { low: { lat: 38.45, lng: -75.79 }, high: { lat: 39.84, lng: -75.05 } },
  [USState.DC]: { low: { lat: 38.79, lng: -77.12 }, high: { lat: 39.0, lng: -76.91 } },
  [USState.HI]: { low: { lat: 18.91, lng: -160.25 }, high: { lat: 22.23, lng: -154.81 } },
  [USState.ID]: { low: { lat: 41.99, lng: -117.24 }, high: { lat: 49.0, lng: -111.04 } },
  [USState.IA]: { low: { lat: 40.38, lng: -96.63 }, high: { lat: 43.5, lng: -90.14 } },
  [USState.KY]: { low: { lat: 36.5, lng: -89.57 }, high: { lat: 39.15, lng: -81.96 } },
  [USState.LA]: { low: { lat: 28.93, lng: -94.04 }, high: { lat: 33.02, lng: -88.82 } },
  [USState.ME]: { low: { lat: 42.98, lng: -71.08 }, high: { lat: 47.46, lng: -66.95 } },
  [USState.MD]: { low: { lat: 37.91, lng: -79.49 }, high: { lat: 39.72, lng: -75.05 } },
  [USState.MA]: { low: { lat: 41.24, lng: -73.51 }, high: { lat: 42.89, lng: -69.93 } },
  [USState.MI]: { low: { lat: 41.7, lng: -90.42 }, high: { lat: 48.24, lng: -82.41 } },
  [USState.MN]: { low: { lat: 43.5, lng: -97.24 }, high: { lat: 49.38, lng: -89.49 } },
  [USState.MS]: { low: { lat: 30.17, lng: -91.66 }, high: { lat: 35.0, lng: -88.1 } },
  [USState.MO]: { low: { lat: 36.0, lng: -95.77 }, high: { lat: 40.61, lng: -89.1 } },
  [USState.MT]: { low: { lat: 44.36, lng: -116.05 }, high: { lat: 49.0, lng: -104.04 } },
  [USState.NE]: { low: { lat: 40.0, lng: -104.05 }, high: { lat: 43.0, lng: -95.31 } },
  [USState.NH]: { low: { lat: 42.7, lng: -72.56 }, high: { lat: 45.31, lng: -70.61 } },
  [USState.NJ]: { low: { lat: 38.93, lng: -75.56 }, high: { lat: 41.36, lng: -73.89 } },
  [USState.NM]: { low: { lat: 31.33, lng: -109.05 }, high: { lat: 37.0, lng: -103.0 } },
  [USState.NY]: { low: { lat: 40.5, lng: -79.76 }, high: { lat: 45.02, lng: -71.86 } },
  [USState.NC]: { low: { lat: 33.84, lng: -84.32 }, high: { lat: 36.59, lng: -75.46 } },
  [USState.ND]: { low: { lat: 45.94, lng: -104.05 }, high: { lat: 49.0, lng: -96.55 } },
  [USState.OK]: { low: { lat: 33.62, lng: -103.0 }, high: { lat: 37.0, lng: -94.43 } },
  [USState.OR]: { low: { lat: 41.99, lng: -124.57 }, high: { lat: 46.29, lng: -116.46 } },
  [USState.PA]: { low: { lat: 39.72, lng: -80.52 }, high: { lat: 42.27, lng: -74.69 } },
  [USState.RI]: { low: { lat: 41.15, lng: -71.86 }, high: { lat: 42.02, lng: -71.12 } },
  [USState.SC]: { low: { lat: 32.03, lng: -83.35 }, high: { lat: 35.22, lng: -78.54 } },
  [USState.SD]: { low: { lat: 42.48, lng: -104.06 }, high: { lat: 45.95, lng: -96.44 } },
  [USState.TN]: { low: { lat: 34.98, lng: -90.31 }, high: { lat: 36.68, lng: -81.65 } },
  [USState.VT]: { low: { lat: 42.73, lng: -73.44 }, high: { lat: 45.02, lng: -71.46 } },
  [USState.VA]: { low: { lat: 36.54, lng: -83.68 }, high: { lat: 39.47, lng: -75.24 } },
  [USState.WA]: { low: { lat: 45.54, lng: -124.76 }, high: { lat: 49.0, lng: -116.92 } },
  [USState.WV]: { low: { lat: 37.2, lng: -82.64 }, high: { lat: 40.64, lng: -77.72 } },
  [USState.WI]: { low: { lat: 42.49, lng: -92.89 }, high: { lat: 47.08, lng: -86.81 } },
  [USState.WY]: { low: { lat: 41.0, lng: -111.06 }, high: { lat: 45.01, lng: -104.05 } },
};

/* Location hint for Google Maps Places API to restrict results to the United States when we don't have a specific state restriction.
Queries will often timeout if we don't provide a location restriction.
*/
export const US_LOCATION_RESTRICTION = {
  rectangle: {
    low: { latitude: 24.396308, longitude: -124.848974 },
    high: { latitude: 49.384358, longitude: -66.93457 },
  },
};

type ParsedAddress = {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  district: string;
  premise: string;
};

export type GeocodedAddress = Pick<ParsedAddress, "line1" | "line2" | "city" | "state" | "postalCode" | "country"> & {
  placeId: string;
};

function parseFormattedAddress(formattedAddress: string) {
  const parts = formattedAddress.split(",").map((part) => part.trim());

  if (parts.length >= 3) {
    const statePostalMatch = parts[2].match(/^([A-Z]{2})\s*(\d{5}(?:-\d{4})?)?$/);

    return {
      line1: parts[0],
      city: parts[1],
      state: statePostalMatch ? statePostalMatch[1].toUpperCase() : parts[2].toUpperCase(),
      postalCode: statePostalMatch?.[2] ?? "",
    };
  }

  if (parts.length === 2) {
    const cityStatePostalMatch = parts[1].match(/^(.+?)\s+([A-Z]{2})\s*(\d{5}(?:-\d{4})?)?$/);

    return cityStatePostalMatch
      ? {
          line1: parts[0],
          city: cityStatePostalMatch[1],
          state: cityStatePostalMatch[2].toUpperCase(),
          postalCode: cityStatePostalMatch[3] ?? "",
        }
      : { line1: parts[0], city: parts[1], state: "", postalCode: "" };
  }

  return { line1: parts[0] ?? "", city: "", state: "", postalCode: "" };
}

function parseAddress({
  placeDetails,
  geocodeInfo,
  components,
}: {
  placeDetails?: Record<string, unknown>;
  geocodeInfo?: Record<string, unknown>;
  components?: Record<string, unknown>;
}): ParsedAddress {
  if (!components) {
    const formattedAddress =
      (placeDetails?.formatted_address as string) || (geocodeInfo?.formatted_address as string) || "";

    return {
      ...parseFormattedAddress(formattedAddress),
      line2: "",
      country: "",
      district: "",
      premise: "",
    };
  }

  const component = (key: string) => {
    const value = components[key];

    return typeof value === "string" ? value : "";
  };

  return {
    line1: [component("street_number"), component("route")].filter(Boolean).join(" "),
    line2: component("subpremise"),
    city:
      component("locality") ||
      component("unincorporated_community") ||
      component("neighborhood") ||
      component("administrative_area_level_3") ||
      component("postal_town") ||
      "",
    state: component("administrative_area_level_1").toUpperCase(),
    postalCode: component("postal_code_suffix")
      ? `${component("postal_code")}-${component("postal_code_suffix")}`
      : component("postal_code"),
    country: component("country"),
    district: component("administrative_area_level_2"),
    premise: component("premise"),
  };
}

/** Normalize Google place details into editable address fields. */
export function buildAddressFromPlaceDetails(placeDetails: Record<string, unknown>, placeId: string): GeocodedAddress {
  const hasStructuredComponents = Boolean(placeDetails.street_number || placeDetails.route || placeDetails.locality);
  const { line1, line2, city, state, postalCode, country } = parseAddress({
    placeDetails,
    components: hasStructuredComponents ? placeDetails : undefined,
  });

  return { line1, line2, city, state, postalCode, country: country || "USA", placeId };
}

export function buildLocation({
  placeDetails,
  geocodeInfo,
  components,
  matchedLocation,
  placeId,
}: {
  placeDetails?: Record<string, unknown>;
  geocodeInfo?: Record<string, unknown>;
  components?: Record<string, unknown>;
  matchedLocation?: Location | null;
  placeId: string;
}): Location {
  const { line1, line2, city, state, postalCode, country, district, premise } = parseAddress({
    placeDetails,
    geocodeInfo,
    components,
  });

  const now = new Date().toISOString();

  return {
    id: uuidv4(),
    name:
      (placeDetails?.name as string) ||
      (geocodeInfo?.name as string) ||
      premise ||
      (placeDetails?.formatted_address as string) ||
      (geocodeInfo?.formatted_address as string) ||
      "New Location",
    facilityType: matchedLocation?.facilityType || null,
    phoneNumber: matchedLocation?.phoneNumber || null,
    alternativePhoneNumbers: matchedLocation?.alternativePhoneNumbers || null,
    faxPhoneNumber: matchedLocation?.faxPhoneNumber || null,
    alternativeFaxPhoneNumbers: matchedLocation?.alternativeFaxPhoneNumbers || null,
    role: matchedLocation?.role || LocationRole.REFERRING_LOCATION,
    address: {
      line1: line1 || "",
      line2: line2 || "",
      city: city || "",
      state: state || "",
      postalCode: postalCode || "",
      district: district || null,
      country: country || null,
      createdAt: now,
      deletedAt: null,
      updatedAt: now,
      id: uuidv4(),
      groupId: "",
      placeId: placeId,
      googlePlaceId: placeId,
      googleLine1: line1 || null,
      googleLine2: line2 || null,
      googleCity: city || null,
      googleDistrict: district || null,
      googleState: state || null,
      googlePostalCode: postalCode || null,
      googleCountry: country || null,
    },
    createdAt: now,
    deletedAt: null,
    updatedAt: now,
    groupId: "",
    placeId: placeId,
    ehrId: null,
    displayId: null,
    isApproved: false,
    isDuplicate: null,
    metadata: null,
  };
}
